__webpack_require__.p = "/effect-note/";